export const blockIconsAudioandvideoNotInterested = (
	<span className='material-symbols-outlined'>not_interested</span>
);
